/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





$(document).ready(function() {
    $('.load-more__button').on('click', function(event) {
      event.preventDefault();

      var nextPageUrl = $(this).data('next-page');

      if (nextPageUrl) {
        $.ajax({
          url: nextPageUrl,
          method: 'GET',
          dataType: 'html',
          success: function(data) {
            var products = $(data).find('.product-list--collection').html();
            var pagination = $(data).find('.pagination').html();

            $('.product-list--collection').append(products);
            $('.pagination').html(pagination);

            var nextUrl = $(data).find('.pagination__next').attr('href');
            $('.load-more__button').data('next-page', nextUrl);

            // If no more pages, hide the "Load More" button
            if (!nextUrl) {
              $('.load-more').hide();
            }
          },
          error: function(xhr, status, error) {
            console.error('Error fetching products:', error);
          }
        });
      }
    });
  });




/* --- Open cart drawer after Add to Cart (DESKTOP ONLY) --- */
(function () {
  // Dawn + many Shopify themes use 990px as the desktop breakpoint.
  // If your theme uses something else, change the query below.
  var DESKTOP_QUERY = '(min-width: 990px)';
  var mql = window.matchMedia(DESKTOP_QUERY);
  var isDesktop = function () { return mql.matches; };

  function openMiniCart() {
    if (!isDesktop()) return; // only on desktop

    var toggle =
      document.querySelector('[data-action^="toggle-mini-cart"]') ||
      document.querySelector('.header__cart-toggle') ||
      document.querySelector('[aria-controls="mini-cart"]');

    if (toggle) {
      if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
    } else {
      // last-resort fallback
      window.location.assign('/cart');
    }
  }

  // If the theme announces adds/refreshes, open the drawer (desktop only)
  document.documentElement.addEventListener('product:added', function(){ if (isDesktop()) openMiniCart(); });
  document.documentElement.addEventListener('cart:refresh', function(){ if (isDesktop()) openMiniCart(); });

  // Force AJAX add-to-cart ONLY on desktop; mobile uses default behavior
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (
        form.matches('form.product-form') ||
        form.matches('form[action^="/cart/add"]')
      ) {
        if (!isDesktop()) return; // let mobile behave as-is

        e.preventDefault();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Add failed');
            return r.json();
          })
          .then(function () {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            openMiniCart();
          })
          .catch(function () {
            // if anything breaks, fall back to normal submission
            form.submit();
          });
      }
    },
    true
  );
})();



// Put this in assets/custom.js (after jQuery is loaded)
(function ($) {
  // target only the Letters field by its name
  const selector = 'input[name="properties[alphabets]"]';

  // Block non-letters on keypress (nice UX)
  $(document).on('keypress', selector, function (e) {
    const k = e.which;
    // allow control keys: backspace, tab, enter, arrows
    if (k === 8 || k === 9 || k === 13 || k === 37 || k === 39) return;
    const ch = String.fromCharCode(k);
    if (!/[A-Za-z\s]/.test(ch)) e.preventDefault();
  });

  // Clean up pasted/auto-filled text (also catches IME & edge cases)
  $(document).on('input', selector, function () {
    this.value = this.value.replace(/[^A-Za-z\s]/g, '');
  });
})(jQuery);


// document.addEventListener('DOMContentLoaded', () => {
//   const swatches = document.querySelectorAll('.cstm_variants .swatch-label');
//   const priceEl = document.querySelector('.price-list .price-regular');

//   if (!priceEl || !swatches.length) return;

//   swatches.forEach((swatch) => {
//     swatch.addEventListener('click', () => {
//       const newPrice = swatch.getAttribute('data-price');
//       if (newPrice) {
//         priceEl.textContent = newPrice;
//       }

//       // Optional: visually mark selected swatch
//       swatches.forEach(s => s.classList.remove('active'));
//       swatch.classList.add('active');
//     });
//   });
// });



// SVGs used for the main gallery icon overlay
const GALLERY_ICON_TRUCK_SVG = '<svg width="20" height="20" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1410_152)"><path d="M4.61133 2.76543H5.43672L5.14972 1.96191H4.61133V2.76543Z" fill="white"/><path d="M5.71875 3.73398C5.71875 3.75279 5.72622 3.77082 5.73952 3.78412C5.75281 3.79741 5.77085 3.80488 5.78965 3.80488H6.02598V3.66309H5.78965C5.77085 3.66309 5.75281 3.67056 5.73952 3.68385C5.72622 3.69715 5.71875 3.71518 5.71875 3.73398Z" fill="white"/><path d="M2.33357 1.5835C2.26301 1.58325 2.19338 1.59955 2.13027 1.63111C2.06716 1.66267 2.01233 1.70859 1.9702 1.76519C1.9633 1.77356 1.95465 1.78031 1.94484 1.78494C1.93503 1.78957 1.92432 1.79197 1.91348 1.79197C1.90263 1.79197 1.89192 1.78957 1.88211 1.78494C1.87231 1.78031 1.86365 1.77356 1.85676 1.76519C1.79953 1.68893 1.71977 1.63261 1.62877 1.6042C1.53776 1.57579 1.44012 1.57673 1.34968 1.60689C1.25924 1.63704 1.18057 1.69488 1.12483 1.77222C1.06908 1.84956 1.03908 1.94248 1.03906 2.03782C1.03906 2.57664 1.75287 2.99863 1.91348 3.08711C2.07418 2.9991 2.78789 2.57759 2.78789 2.03782C2.78777 1.91736 2.73986 1.80188 2.65469 1.7167C2.56951 1.63153 2.45403 1.58362 2.33357 1.5835Z" fill="#B9A5AC"/><path d="M3.52109 0.874512H0.307031C0.231817 0.874512 0.159684 0.90439 0.1065 0.957574C0.053316 1.01076 0.0234375 1.08289 0.0234375 1.15811V3.52139H0.259766C0.316176 3.52139 0.370276 3.5438 0.410164 3.58368C0.450052 3.62357 0.472461 3.67767 0.472461 3.73408C0.472461 3.79049 0.450052 3.84459 0.410164 3.88448C0.370276 3.92437 0.316176 3.94678 0.259766 3.94678H0.0234375V4.18311H0.566992C0.632938 4.09492 0.71854 4.02332 0.816999 3.974C0.915458 3.92468 1.02406 3.89901 1.13418 3.89901C1.2443 3.89901 1.3529 3.92468 1.45136 3.974C1.54982 4.02332 1.63542 4.09492 1.70137 4.18311H3.80469V1.15811C3.80469 1.08289 3.77481 1.01076 3.72162 0.957574C3.66844 0.90439 3.59631 0.874512 3.52109 0.874512ZM1.94573 3.23033C1.9359 3.23523 1.92505 3.23779 1.91406 3.23779C1.90307 3.23779 1.89223 3.23523 1.88239 3.23033C1.84212 3.21019 0.897852 2.73007 0.897852 2.03781C0.898027 1.87977 0.960888 1.72825 1.07264 1.61649C1.1844 1.50474 1.33592 1.44187 1.49397 1.4417C1.57195 1.44138 1.64923 1.45651 1.72133 1.48622C1.79343 1.51592 1.85894 1.55962 1.91406 1.61479C1.96919 1.55962 2.03469 1.51592 2.1068 1.48622C2.1789 1.45651 2.25618 1.44138 2.33416 1.4417C2.4922 1.44187 2.64373 1.50474 2.75548 1.61649C2.86724 1.72825 2.9301 1.87977 2.93027 2.03781C2.93027 2.73007 1.986 3.21019 1.94573 3.23033Z" fill="white"/><path d="M5.82904 3.04893L5.54544 2.90713H4.25254C4.23374 2.90713 4.2157 2.89966 4.20241 2.88636C4.18911 2.87307 4.18164 2.85503 4.18164 2.83623V1.89092C4.18164 1.87211 4.18911 1.85408 4.20241 1.84079C4.2157 1.82749 4.23374 1.82002 4.25254 1.82002H5.09926L5.04821 1.67718C5.02355 1.60838 4.97827 1.54886 4.91853 1.50675C4.85879 1.46464 4.78751 1.44199 4.71442 1.44189H3.94531V4.1833H4.34707C4.41302 4.09511 4.49862 4.02351 4.59708 3.9742C4.69554 3.92488 4.80414 3.8992 4.91426 3.8992C5.02438 3.8992 5.13298 3.92488 5.23144 3.9742C5.3299 4.02351 5.4155 4.09511 5.48145 4.1833H6.025V3.94697H5.78867C5.73226 3.94697 5.67816 3.92456 5.63827 3.88468C5.59839 3.84479 5.57598 3.79069 5.57598 3.73428C5.57598 3.67787 5.59839 3.62377 5.63827 3.58388C5.67816 3.54399 5.73226 3.52158 5.78867 3.52158H6.025V3.36561C6.02517 3.29979 6.0069 3.23524 5.97227 3.17927C5.93763 3.1233 5.88801 3.07815 5.82904 3.04893ZM4.53613 3.28525H4.25254C4.23374 3.28525 4.2157 3.27778 4.20241 3.26449C4.18911 3.25119 4.18164 3.23316 4.18164 3.21436C4.18164 3.19555 4.18911 3.17752 4.20241 3.16422C4.2157 3.15093 4.23374 3.14346 4.25254 3.14346H4.53613C4.55494 3.14346 4.57297 3.15093 4.58627 3.16422C4.59956 3.17752 4.60703 3.19555 4.60703 3.21436C4.60703 3.23316 4.59956 3.25119 4.58627 3.26449C4.57297 3.27778 4.55494 3.28525 4.53613 3.28525Z" fill="white"/><path d="M4.91484 4.04102C4.80266 4.04102 4.69301 4.07428 4.59973 4.1366C4.50646 4.19893 4.43376 4.28751 4.39083 4.39115C4.3479 4.49479 4.33667 4.60883 4.35855 4.71886C4.38044 4.82888 4.43446 4.92994 4.51378 5.00927C4.5931 5.08859 4.69417 5.14261 4.80419 5.16449C4.91421 5.18638 5.02826 5.17515 5.1319 5.13222C5.23554 5.08929 5.32412 5.01659 5.38644 4.92332C5.44877 4.83004 5.48203 4.72038 5.48203 4.6082C5.48203 4.45778 5.42227 4.31351 5.31591 4.20714C5.20954 4.10077 5.06527 4.04102 4.91484 4.04102ZM4.91484 4.91543C4.85408 4.91543 4.79468 4.89741 4.74416 4.86365C4.69364 4.82989 4.65426 4.78191 4.631 4.72577C4.60775 4.66964 4.60167 4.60786 4.61352 4.54827C4.62538 4.48867 4.65464 4.43393 4.6976 4.39096C4.74057 4.34799 4.79531 4.31873 4.85491 4.30688C4.9145 4.29503 4.97628 4.30111 5.03241 4.32436C5.08855 4.34762 5.13654 4.38699 5.17029 4.43752C5.20405 4.48804 5.22207 4.54744 5.22207 4.6082C5.22197 4.68965 5.18957 4.76774 5.13198 4.82533C5.07438 4.88293 4.99629 4.91533 4.91484 4.91543Z" fill="white"/><path d="M4.91543 4.77422C5.00679 4.77422 5.08086 4.70015 5.08086 4.60879C5.08086 4.51742 5.00679 4.44336 4.91543 4.44336C4.82407 4.44336 4.75 4.51742 4.75 4.60879C4.75 4.70015 4.82407 4.77422 4.91543 4.77422Z" fill="#B9A5AC"/><path d="M1.13223 4.77422C1.22359 4.77422 1.29766 4.70015 1.29766 4.60879C1.29766 4.51742 1.22359 4.44336 1.13223 4.44336C1.04086 4.44336 0.966797 4.51742 0.966797 4.60879C0.966797 4.70015 1.04086 4.77422 1.13223 4.77422Z" fill="#B9A5AC"/><path d="M1.13359 4.04102C1.02141 4.04102 0.911755 4.07428 0.818482 4.1366C0.725208 4.19893 0.65251 4.28751 0.609581 4.39115C0.566652 4.49479 0.55542 4.60883 0.577305 4.71886C0.59919 4.82888 0.653209 4.92994 0.732532 5.00927C0.811855 5.08859 0.912918 5.14261 1.02294 5.16449C1.13296 5.18638 1.24701 5.17515 1.35065 5.13222C1.45429 5.08929 1.54287 5.01659 1.60519 4.92332C1.66752 4.83004 1.70078 4.72038 1.70078 4.6082C1.70078 4.45778 1.64102 4.31351 1.53466 4.20714C1.42829 4.10077 1.28402 4.04102 1.13359 4.04102ZM1.13359 4.91543C1.07283 4.91543 1.01343 4.89741 0.962908 4.86365C0.912385 4.82989 0.873007 4.78191 0.849754 4.72577C0.8265 4.66964 0.820416 4.60786 0.832271 4.54827C0.844125 4.48867 0.873386 4.43393 0.916352 4.39096C0.959318 4.34799 1.01406 4.31873 1.07366 4.30688C1.13325 4.29503 1.19503 4.30111 1.25116 4.32436C1.3073 4.34762 1.35529 4.38699 1.38904 4.43752C1.4228 4.48804 1.44082 4.54744 1.44082 4.6082C1.44072 4.68965 1.40832 4.76774 1.35073 4.82533C1.29313 4.88293 1.21504 4.91533 1.13359 4.91543Z" fill="white"/><path d="M5.62568 4.60879C5.62568 4.64041 5.62356 4.67199 5.61934 4.70332H5.95654C5.97534 4.70332 5.99337 4.69585 6.00667 4.68255C6.01997 4.66926 6.02744 4.65123 6.02744 4.63242V4.3252H5.56641C5.6056 4.4146 5.62578 4.51117 5.62568 4.60879Z" fill="white"/><path d="M3.94531 4.3252V4.70332H4.21161C4.1943 4.57481 4.21262 4.44401 4.26454 4.3252H3.94531Z" fill="white"/><path d="M1.84443 4.60879C1.84443 4.64041 1.84231 4.67199 1.83809 4.70332H3.80595V4.3252H1.78516C1.82435 4.4146 1.84453 4.51117 1.84443 4.60879Z" fill="white"/><path d="M0.0234375 4.3252V4.63242C0.0234375 4.65123 0.0309071 4.66926 0.0442032 4.68255C0.0574992 4.69585 0.0755325 4.70332 0.0943359 4.70332H0.431529C0.414226 4.57481 0.432538 4.44401 0.484466 4.3252H0.0234375Z" fill="white"/></g><defs><clipPath id="clip0_1410_152"><rect width="6.05" height="6.05" fill="white"/></clipPath></defs></svg>';

const GALLERY_ICON_BALLOON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 25 40"><circle cx="12.5" cy="12.5" r="10" fill="#ffffff" stroke="#ffffff" stroke-width="1"/><polygon points="11.5,25 12.5,27 13.5,25" fill="#ffffff" stroke="#ffffff"/><line x1="12.5" y1="27" x2="12.5" y2="40" stroke="#ffffff" stroke-width="1"/></svg>';

function syncGalleryTooltipIcon(swatch) {
  const galleryIcons = document.querySelectorAll('.gallery-tooltip-icon');
  if (!galleryIcons.length || !swatch) return;

  // Desktop swatches have .v--title (e.g. "12 Balloons"); mobile only has data-variant-title (e.g. "12")
  const titleEl = swatch.querySelector('.v--title');
  const desktopTitle = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
  const dataTitle = (swatch.getAttribute('data-variant-title') || '').trim();
  const tooltipRaw = swatch.getAttribute('data-tooltip') || '';
  const tooltipLc = tooltipRaw.toLowerCase();

  const is18 = desktopTitle === '18 Balloons' || dataTitle === '18';
  const is12 = desktopTitle === '12 Balloons' || dataTitle === '12';

  let svg = '';
  let modifier = '';
  let labelText = '';

  if (is18) {
    if (tooltipLc.indexOf('free delivery') !== -1) {
      svg = GALLERY_ICON_TRUCK_SVG;
      modifier = 'class-free-delivery';
    } else {
      svg = GALLERY_ICON_BALLOON_SVG;
      modifier = 'class-free-centrepiece';
    }
    labelText = tooltipRaw;
  } else if (is12) {
    svg = GALLERY_ICON_BALLOON_SVG;
    modifier = 'class-free-centrepiece';
    labelText = tooltipRaw;
  }

  galleryIcons.forEach((icon) => {
    // reset any previously-added modifier classes
    icon.classList.remove('class-free-delivery', 'class-free-centrepiece', 'class-free-greeting-card');

    if (!svg) {
      icon.style.display = 'none';
      const badge = icon.querySelector('.gallery-tooltip-badge');
      const label = icon.querySelector('.gallery-tooltip-label');
      if (badge) badge.innerHTML = '';
      if (label) label.textContent = '';
      return;
    }

    if (modifier) icon.classList.add(modifier);
    icon.style.display = 'inline-flex';

    const badge = icon.querySelector('.gallery-tooltip-badge');
    const label = icon.querySelector('.gallery-tooltip-label');
    if (badge) badge.innerHTML = svg;
    if (label) {
      if (labelText) {
        label.textContent = labelText;
        label.style.display = 'inline-block';
      } else {
        label.textContent = '';
        label.style.display = 'none';
      }
    }
  });
}

// Writes the "Ballons Details" line item property for a swatch into its form.
// Must run on page load as well as on click: a customer who accepts the
// pre-selected variant never clicks a swatch, and without this the property
// (and therefore the cart attribute derived from it) never reaches the order.
function syncBallonsDetailsInput(swatch) {
  if (!swatch) return;
  const form = swatch.closest('form[action*="/cart/add"]');
  if (!form) return;

  const tooltipText = (swatch.getAttribute('data-tooltip') || '').trim();
  let input = form.querySelector('input[name="properties[Ballons Details]"]');

  if (tooltipText !== '') {
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Ballons Details]';
      form.appendChild(input);
    }
    input.value = tooltipText;
  } else if (input) {
    // Remove rather than blank it, so empty properties never reach the order.
    input.remove();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const swatches = document.querySelectorAll('.cstm_variants .swatch-label');
  const priceRegularEl = document.querySelector('.price-list .price-regular');

  if (!swatches.length) return;

  // Initial sync. The selected variant is marked by `checked` on the radio
  // (Liquid uses selected_or_first_available_variant, so it honours ?variant=),
  // NOT by an .active class - that is only added later by the click handler.
  // Reading .active here picked the wrong swatch on direct variant links.
  //
  // Done per form: a product page can render two add-to-cart forms (desktop
  // gallery and mobile gallery), and each needs its own property input.
  const forms = new Set();
  swatches.forEach((s) => {
    const f = s.closest('form[action*="/cart/add"]');
    if (f) forms.add(f);
  });

  let initialSwatch = null;

  // The two galleries associate a radio with its label differently:
  // desktop uses id/for, mobile nests the radio inside the label.
  const labelForInput = (form, input) => {
    if (!input) return null;
    if (input.id) {
      const byFor = form.querySelector('.swatch-label[for="' + input.id + '"]');
      if (byFor) return byFor;
    }
    return input.closest('.swatch-label');
  };

  forms.forEach((form) => {
    const checkedInput = form.querySelector('.cstm_variants input[name="id"]:checked');
    const checkedLabel = labelForInput(form, checkedInput);
    const swatch =
      checkedLabel ||
      form.querySelector('.cstm_variants .swatch-label.active') ||
      form.querySelector('.cstm_variants .swatch-label');

    if (!swatch) return;

    // Keep the visual state consistent with the variant actually selected.
    swatch.classList.add('active');
    syncBallonsDetailsInput(swatch);

    if (!initialSwatch) initialSwatch = swatch;
  });

  // Gallery icon is page-level, not per-form.
  syncGalleryTooltipIcon(initialSwatch || swatches[0]);

  swatches.forEach((swatch) => {
    const form = swatch.closest('form[action*="/cart/add"]');
    if (!form) return;
    const tooltipTextEl = form.querySelector('.swatch-tooltip-text'); // tooltip inside this form
    //const priceRegularEl = form.querySelector('.price-regular');
    swatch.addEventListener('click', () => {
      const price = swatch.getAttribute('data-price') || "";
      const comparePrice = swatch.getAttribute('data-compare-price') || "";
      const tooltipText = swatch.getAttribute('data-tooltip') || "";
      const freePersonalizedCard = swatch.getAttribute('data-free-personalized-card') === "true";
      const freePersonalizedUrl = swatch.getAttribute('data-personalised-link') || "";
      // helper to convert "PKR 5,000" / "$5000" → 5000
      function parsePrice(value) {
        return Number(value.replace(/[^0-9.]/g, ''));
      }

      // Update prices (Regular and showing the Compare Pricing)
    
      if (comparePrice !== "") {
        const sale = parsePrice(price);
        const compare = parsePrice(comparePrice);

        let savePercent = "";
        if (compare > sale && compare > 0) {
          savePercent = Math.round(((compare - sale) / compare) * 100);
        }

        priceRegularEl.innerHTML = `
          <span class="price-compare"><s>${comparePrice}</s></span>
          <span class="price-sale with-sale-badge">${price}</span>
          ${savePercent ? `<span class="price-save"> ${savePercent}% Off</span>` : ""}
        `;
      } else {
        priceRegularEl.textContent = price;
      }
      

      // Update tooltip text for this form only
      if (tooltipTextEl) tooltipTextEl.textContent = tooltipText;

      // Mark active swatch in this form only
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Update main gallery icon for 12 / 18 variants
      syncGalleryTooltipIcon(swatch);

      // Handle hidden input for this form
      syncBallonsDetailsInput(swatch);

      // Store metafield info for personalized card
      form.dataset.freePersonalizedCard = freePersonalizedCard ? "true" : "false";
      if (freePersonalizedUrl) {
        form.dataset.freePersonalizedUrl = freePersonalizedUrl;
      } else {
        delete form.dataset.freePersonalizedUrl;
      }
      // OOS Product CHECK
      const isAvailable = swatch.getAttribute('data-variant-available') === 'true';
      

      // Select both buttons inside the same form
      const buttons = form.querySelectorAll(
        '.product-form__add-button, .mobile-add-to-cart-btn'
      );

      buttons.forEach((btn) => {
        if (!btn) return;

        // Find text node (keep icons/spans intact)
        let textNode = [...btn.childNodes].find(
          node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
        );

        if (!textNode) {
          textNode = document.createTextNode(' Add to cart');
          btn.appendChild(textNode);
        }

        if (!isAvailable) {
          btn.disabled = true;
          btn.classList.add('sold-out', 'button--disabled');
          textNode.textContent = ' Sold Out';
        } else {
          btn.disabled = false;
          btn.classList.remove('sold-out', 'button--disabled');
          textNode.textContent = ' Add to cart';
        }
      });
      
    });
  });

  // Add to Cart button click
  document.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach(button => {
    button.addEventListener('click', (event) => {
      const form = button.closest('form[action*="/cart/add"]');
      if (!form) return;

      const input = form.querySelector('input[name="properties[Ballons Details]"]');
      if (input) console.log("Submitting with tooltip:", input.value);

      // Redirect if product has free personalized card
      // if (form.dataset.freePersonalizedCard === "true") {
      //   setTimeout(() => {
      //     // Dynamically read metafield product URL if available
      //     const url = form.dataset.freePersonalizedUrl || "/a/greeting-cards/";
      //     window.location.href = url;
      //   }, 750);
      // }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tooltip]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent click from bubbling
      el.classList.toggle('active'); // Show tooltip on click

      // Optional: hide tooltip after 3 seconds
      setTimeout(() => {
        el.classList.remove('active');
      }, 3000);
    });
  });

  // Hide tooltip if clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-tooltip].active').forEach(el => {
      el.classList.remove('active');
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const productLists = document.querySelectorAll('.product-list.product-list--collection');
  if (!productLists.length) return;

  function fixGreetingCard(productList) {
    const cards = productList.querySelectorAll('.product-greeting-card');
    if (!cards.length) return;

    // Remove all but the last greeting card
    cards.forEach((card, index) => {
      if (index !== cards.length - 1) {
        card.remove();
      }
    });

    // Ensure greeting card is LAST
    const lastCard = cards[cards.length - 1];
    if (lastCard !== productList.lastElementChild) {
      productList.appendChild(lastCard);
    }
  }

  productLists.forEach((productList) => {
    // Initial fix
    fixGreetingCard(productList);

    // Observe AJAX appends
    const observer = new MutationObserver(() => {
      fixGreetingCard(productList);
    });

    observer.observe(productList, { childList: true });
  });
});


/*** Scroll to Top */
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('scrollToTop');
  const footer = document.querySelector('.footer');

  if (!btn || !footer) return;

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;

    // start showing from center
    if (scrollTop >= windowHeight / 2) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  });

  btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});
